import React, {Component, PureComponent} from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper/index'
import {TableComp} from 'sz-react-utils'
// import GetAllFormFields from '../../../components/_utils/formUtils'
import {Button, Card, Form,Row,Col, Tooltip, DatePicker, Select, Drawer, notification} from 'antd';
import {FormUtils as GetAllFormFields} from 'sz-react-utils'
import _ from 'lodash'
import Request, { API_URL } from '../../request'
import {connect} from 'react-redux'
import moment from 'moment'


@Form.create()
class GenerateProgramCodes extends Component {
    state={
        visible:true
    }

    onClose = () =>{
        setTimeout(()=>{
            this.props.onClose()
        }, 50)
    }

    handleSubmit = (e) =>{
        let {form} = this.props;
        e.preventDefault();
        form.validateFieldsAndScroll(async(err,valData)=>{
            let values = _.clone(valData);
            let response = await Request.generateLoyalityCodes(values);
            if(response.success) {
                notification.success({
                    message:response.message
                })
            }else {
                notification.error({
                    message:'Something Went Wrong'
                })
            }
            this.onClose()
        })
    }

    render() {
        let {visible} = this.state
        let {form:{getFieldDecorator}} = this.props
        let inputTypes = {
            fields:[
                {
                    label:'How Many Numbers',
                    key:'generateAmount',
                    type:'number'
                }
            ]
        }
        return (
            <Drawer
            title={`Generate Loyalty Program Codes`}
            placement="right"
            closable={true}
            onClose={this.onClose}
            visible={visible}
            width={500}>
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields getFieldDecorator={getFieldDecorator} apiurl={API_URL} inputSchema={inputTypes} />
                        <Row style={{marginTop:'20px'}}>
                            <Col span={8}/>
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{marginBottom: 10}}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8}/>
                        </Row>
                    </Form>
                </Card>

            </Drawer>
        )
    }
}





@Form.create()
class LoyalityCodes extends PureComponent {
    state = {
        studentId: '',
        count: 0,
        defaultPageSize: 20,
        month:moment(),
        activityArr: [],
        record:{},
        allUsers:[],
        userId:null,
        showAppraisalAddForm:false,
        showAppraisalEditForm:false,
        showAprraisalRequestEdit:false,
        showApprovalByManagement:false,
        activeUser:{},
        showGenerateCodeDrawer:false
    }



    refreshFxn = () => {
        this.setState({refreshChild: !this.state.refreshChild})
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    handleAppraisalRequestEdit = (record)=>{
        this.setState({showAprraisalRequestEdit:true, record:record})
    }

    handleActionByManagement = (record) =>{
        this.setState({showApprovalByManagement:true, record:record})
    }

    closeEditForm = () =>{
        this.setState({showAprraisalRequestEdit:false, record:{}, showApprovalByManagement:false})
        this.table.current.reload()
    }

    handleStaffLeaveApplication = (record) =>{
        this.setState({showLeaveActionForm:true, record:record})
    }

    handleStaffLeaveApplicationClose = () =>{
        this.setState({showLeaveActionForm:false, record:{}})
        this.table.current.reload()
    }

    handleGenerateCodes = () =>{
        this.setState({showGenerateCodeDrawer:true})
    }

    closeGenerateCodeDrawer = () =>{
        this.setState({showGenerateCodeDrawer:false}, ()=>{
            this.table.current.reload()
        })
    }

    handleAdd=()=>{
        this.setState({showAppraisalAddForm:true})
    }

    handleClose = () =>{
        this.setState({showLeaveAddForm:false})
        this.reload()
    }

    onClose = () =>{
        this.setState({showAppraisalAddForm:false, record:{}, viewDetailRecord:{}, showAppraisalEditForm:false})
        this.reload()
    }

    apiRequest = params =>{
        return new Promise(async(resolve)=>{
            params.sortField = "membershipCode"
            params.sortOrder = "ascend"
            if(this.state.userId) {
                params.userId = this.state.userId
            }
            let response = await Request.getAllLoyalityCodes(params)
            this.setState({count:response.total})
            resolve(response)
        })
    }

    getCurrentUser() {
        let response = JSON.parse(localStorage.getItem('user'));
        this.setState({activeUser:response})
        return response
    }

    handleMonthChange = (month,dateString) =>{
        this.setState({month:moment(month)}, ()=>{
            this.reload()
        })
    }


    handleAppraisalEdit = (data) =>{
        this.setState({record:data, showAppraisalEditForm:true})
    }

    async componentDidMount() {
        let currentUser = await this.getCurrentUser()
        let params = {
            sortField:'_id',
            sortOrder:'ascend',
            results: 200,
            active:true,
            userType:{$ne : "Student"},
            userBranch:currentUser.userBranch,
        };
        let response = await Request.loadUser({...params, regExFilters: ['name']})
        let userArray = [];
        response.data.map((user, index)=>{
            userArray.push({
                _id: user._id,
                display: user.name
            })
        })
        this.setState({allUsers:userArray})
    }

    reload = () => {    
        this.table.current.reload();
    };

    render() {
        const {defaultPageSize,showApprovalByManagement, showGenerateCodeDrawer, showLeaveActionForm,showAprraisalRequestEdit, activeUser, count, record, allUsers, showAppraisalAddForm, showAppraisalEditForm} = this.state
        const columns = [
            {
                title:'Membership Code',
                key:'membershipCode',
                searchTextName:'Membership Code',
                filterRegex:true
            },
            {
                title:'Status',
                key:'status',
                filters:[{value:"Assigned", text:"Assigned"}, {value:"Not Assigned", text:"Not Assigned"}]
            },
            {
                title: 'Added By',
                key: 'createdByName',
                dataIndex: 'createdByName',
                render: (text, record) => {
                  return (
                    <div>
                      <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
                      <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : '' }</small>
                    </div>
                  )
                }
            }
        ]
        
    return (
        <PageHeaderWrapper title={`Program Codes:- ${count}` }>

            {
                showGenerateCodeDrawer?
                <GenerateProgramCodes onClose={this.closeGenerateCodeDrawer} />
                :null
            }
            
            <Card bordered={true}>
                <Row>
                    <Col span={2}>
                        <div style={{textAlign: 'right', marginTop: '15px'}}>
                            <Button onClick={()=>this.handleGenerateCodes()}>Generate Codes</Button>
                        </div>
                    </Col>
                </Row>
            </Card>
            <Card bordered={true} >
                <TableComp
                    ref={this.table}
                    columns={columns}
                    apiRequest={this.apiRequest}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: defaultPageSize,
                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                    }}
                />
            </Card>

        </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoyalityCodes)
